import { effect } from '@angular/core';
import {
	getState,
	patchState,
	signalStore,
	withHooks,
	withMethods,
	withState,
} from '@ngrx/signals';
import { UserSettingDto } from 'app/core/services/api.service';

type UserSettingState = {
	userSettings: UserSettingDto[];
};

const initialState: UserSettingState = {
	userSettings: [],
};

export const UserSettingsStore = signalStore(
	{ providedIn: 'root' },

	withState(initialState),

	withMethods((store) => {
		return {
			initializeUserSettings: (userSettings: UserSettingDto[]) => {
				patchState(store, { userSettings: userSettings ?? [] });
			},
			getUserSettingByKey: (key: string) => {
				const state = getState(store);
				const userSettings = state.userSettings ?? [];
				return userSettings.find((setting) => setting.key === key)
					?.value;
			},
			updateUserSetting: (key: string, value: string) => {
				const state = getState(store);
				const existingSettingIndex = state.userSettings.findIndex(
					(setting) => setting.key === key
				);

				const updatedSettings = [...state.userSettings];
				if (existingSettingIndex >= 0) {
					updatedSettings[existingSettingIndex] = {
						...updatedSettings[existingSettingIndex],
						value,
					} as UserSettingDto;
				} else {
					updatedSettings.push({ key, value } as UserSettingDto);
				}

				patchState(store, { userSettings: updatedSettings });
			},
			signOff: () => {
				localStorage.removeItem('userSettings');
				patchState(store, initialState);
			},
		};
	}),

	withHooks({
		onInit(store) {
			try {
				const userSettingsFromStorage = JSON.parse(
					localStorage.getItem('userSettings') ?? '[]'
				);
				patchState(store, { userSettings: userSettingsFromStorage });
			} catch (error) {
				console.error('Failed to parse user settings:', error);
				patchState(store, { userSettings: [] });
			}

			effect(() => {
				const state = getState(store);
				try {
					localStorage.setItem(
						'userSettings',
						JSON.stringify(state.userSettings)
					);
				} catch (error) {
					console.error('Failed to save user settings:', error);
				}
			});
		},
	})
);
